<template>
  <section class="features">
    <div class="main-container">
      <h2 class="features__header heading heading--md heading--underlined">
        Game Features
      </h2>
      <ul v-if="features" ref="features" class="features__list">
        <li
          v-for="(feature, index) in features"
          :key="index"
          class="features__item"
        >
          <div class="features__item-icon" v-html="feature.icon"></div>
          <div class="features__item-text">
            {{ feature.text }}
          </div>
        </li>
      </ul>
      <!--<div class="features__note">-->
      <!--<h3 class="features__note-header">IMPORTANT NOTE:</h3>-->
      <!--<p class="features__note-text">-->
      <!--<span class="line">Only the browser version of MiniDAYZ supports the multiplayer mode and drivable cars feature.</span>-->
      <!--<span class="line">Also, maps are pre-created there.</span>-->
      <!--</p>-->
      <!--</div>-->
    </div>
  </section></template
>
<script>
import Features from "./Features";

export default {
  data() {
    return {
      features: Features
    };
  }
};
</script>
